import React, { createContext, useContext } from 'react'

const BasePathContext = createContext('/google-font-explorer/pairings')

export function BasePathProvider({ value, children }: { value: string; children: React.ReactNode }) {
  return <BasePathContext.Provider value={value}>{children}</BasePathContext.Provider>
}

export function useBasePath() {
  return useContext(BasePathContext)
}
